import appleTrees from "../../../assets/images/background/farm/apple_trees.png";
import cows from "../../../assets/images/background/farm/cows.png";
import field from "../../../assets/images/background/farm/field.png";
import fieldHall from "../../../assets/images/background/farm/field_hall.png";
import fieldRows from "../../../assets/images/background/farm/field_rows.png";
import fieldTractor from "../../../assets/images/background/farm/field_tractor.png";
import fieldUp from "../../../assets/images/background/farm/field_up.png";
import fieldUpLeft from "../../../assets/images/background/farm/field_up_left.png";
import garden from "../../../assets/images/background/farm/garden.png";
import greenhouses from "../../../assets/images/background/farm/greenhouses.png";
import photovoltaic from "../../../assets/images/background/farm/photovoltaic.png";
import start from "../../../assets/images/background/farm/start.png";
import street from "../../../assets/images/background/farm/street.png";
import streetCorner from "../../../assets/images/background/farm/street_corner.png";
import streetLake from "../../../assets/images/background/farm/street_lake.png";
import streetStraight from "../../../assets/images/background/farm/street_straight.png";
import streetT from "../../../assets/images/background/farm/street_t.png";
import trees from "../../../assets/images/background/farm/trees.png";

// Shared Wall Definitions

const WALLS = {
	EMPTY: [],
	// Used by apple_trees, cows, garden, greenhouses, photovoltaic, start
	ENCLOSED_AREA: [
		{ x1: 4, y1: 100, x2: 36, y2: 100 },
		{ x1: 36, y1: 100, x2: 36, y2: 71 },
		{ x1: 63, y1: 71, x2: 63, y2: 100 },
		{ x1: 63, y1: 100, x2: 95, y2: 100 },
		{ x1: 95, y1: 100, x2: 95, y2: 5 },
		{ x1: 4, y1: 5, x2: 95, y2: 5 },
		{ x1: 4, y1: 5, x2: 4, y2: 100 },
	],
	STREET_STRAIGHT: [
		{ x1: 0, y1: 36, x2: 100, y2: 36 },
		{ x1: 0, y1: 64, x2: 100, y2: 64 },
	],
};

// Shared POI Definitions

const POIS = {
	NONE: { name: "", items: [] },
	CENTER: (name) => ({
		name,
		items: [{ x: 50, y: 50 }]
	}),
	BOTTOM_CENTER: (name) => ({
		name,
		items: [{ x: 50, y: 91 }]
	}),
};

// Component Factory Helper 

const create = (id, image, text, pois, walls = WALLS.EMPTY, waters = []) => ({
	id,
	image,
	text,
	pois,
	walls,
	waters,
});

const farm = {
	name: "Farm",
	components: {
		apple_trees: create("apple_trees", appleTrees, "Apple Trees", POIS.BOTTOM_CENTER("apple_trees"), WALLS.ENCLOSED_AREA),
		cows: create("cows", cows, "Cows", { name: "cows", items: [{ x: 50, y: 35 }] }, WALLS.ENCLOSED_AREA),
		garden: create("garden", garden, "Garden", POIS.BOTTOM_CENTER("garden"), WALLS.ENCLOSED_AREA),
		greenhouses: create("greenhouses", greenhouses, "Greenhouses", POIS.BOTTOM_CENTER("greenhouse"), WALLS.ENCLOSED_AREA),
		photovoltaic: create("photovoltaic", photovoltaic, "Photovoltaic", POIS.BOTTOM_CENTER("photovoltaic"), WALLS.ENCLOSED_AREA),
		start: create("start", start, "Start",
			{ name: "start", items: [{ x: 50, y: 91 }, { x: 50, y: 51 }] },
			WALLS.ENCLOSED_AREA
		),

		field: create("field", field, "Field", POIS.CENTER("field")),
		fieldRows: create("fieldRows", fieldRows, "Field Rows", POIS.NONE),
		fieldTractor: create("fieldTractor", fieldTractor, "Field Tractor", POIS.NONE),
		fieldHall: create("fieldHall", fieldHall, "Field Hall",
			{ name: "field", items: [{ x: 17, y: 50 }, { x: 83, y: 50 }] },
			[
				{ x1: 36, y1: 0, x2: 36, y2: 36 },
				{ x1: 36, y1: 36, x2: 0, y2: 36 },
				{ x1: 0, y1: 64, x2: 36, y2: 64 },
				{ x1: 36, y1: 64, x2: 36, y2: 100 },
			]
		),
		fieldUp: create("fieldUp", fieldUp, "Field Up",
			{ name: "field", items: [{ x: 50, y: 25 }] },
			[{ x1: 0, y1: 64, x2: 100, y2: 64 }]
		),
		fieldUpLeft: create("fieldUpLeft", fieldUpLeft, "Field Up Left",
			{ name: "field", items: [{ x: 75, y: 25 }] },
			[
				{ x1: 36, y1: 0, x2: 36, y2: 64 },
				{ x1: 36, y1: 64, x2: 100, y2: 64 },
			]
		),

		street: create("street", street, "Street", POIS.CENTER("street"), [
			{ x1: 0, y1: 36, x2: 36, y2: 36 },
			{ x1: 36, y1: 36, x2: 36, y2: 0 },
			{ x1: 0, y1: 64, x2: 36, y2: 64 },
			{ x1: 36, y1: 64, x2: 36, y2: 100 },
			{ x1: 64, y1: 100, x2: 64, y2: 64 },
			{ x1: 64, y1: 64, x2: 100, y2: 64 },
			{ x1: 100, y1: 36, x2: 64, y2: 36 },
			{ x1: 64, y1: 36, x2: 64, y2: 0 },
		]),
		street_corner: create("street_corner", streetCorner, "Street Corner",
			{ name: "street", items: [{ x: 50, y: 17 }, { x: 50, y: 50 }, { x: 83, y: 50 }] },
			[
				{ x1: 36, y1: 0, x2: 36, y2: 64 },
				{ x1: 36, y1: 64, x2: 100, y2: 64 },
				{ x1: 64, y1: 0, x2: 64, y2: 36 },
				{ x1: 64, y1: 36, x2: 100, y2: 36 },
			]
		),
		streetLake: create("streetLake", streetLake, "Street Lake", POIS.CENTER("street"),
			[
				{ x1: 0, y1: 36, x2: 20, y2: 41 },
				{ x1: 20, y1: 41, x2: 80, y2: 41 },
				{ x1: 80, y1: 41, x2: 100, y2: 36 },
				{ x1: 0, y1: 64, x2: 20, y2: 59 },
				{ x1: 20, y1: 59, x2: 80, y2: 59 },
				{ x1: 80, y1: 59, x2: 100, y2: 64 },
				{ x1: 28, y1: 77, x2: 30, y2: 91 },
				{ x1: 30, y1: 91, x2: 42, y2: 95 },
				{ x1: 42, y1: 95, x2: 59, y2: 94 },
				{ x1: 59, y1: 94, x2: 68, y2: 69 },
				{ x1: 68, y1: 69, x2: 56, y2: 63 },
				{ x1: 56, y1: 63, x2: 47, y2: 69 },
				{ x1: 47, y1: 69, x2: 36, y2: 65 },
				{ x1: 36, y1: 65, x2: 28, y2: 77 },
			],
			[{ x: 48, y: 80, range: 15 }]
		),
		street_straight: create("street_straight", streetStraight, "Street Straight", POIS.CENTER("street"), WALLS.STREET_STRAIGHT),
		street_t: create("street_t", streetT, "Street T", POIS.CENTER("street"), [
			{ x1: 0, y1: 36, x2: 36, y2: 36 },
			{ x1: 36, y1: 36, x2: 36, y2: 0 },
			{ x1: 0, y1: 64, x2: 100, y2: 64 },
			{ x1: 100, y1: 36, x2: 64, y2: 36 },
			{ x1: 64, y1: 36, x2: 64, y2: 0 },
		]),

		trees: create("trees", trees, "Trees", POIS.NONE),
	},
};

export default farm;